export const NOTIFICATION_EVENTS = {
  viewCtpOptIn: 'ICON_CTP_CLICK',
  dismissCtpOptIn: 'ICON_CTP_DISMISS',
};

export const NOTIFICATIONS = {
  ctpOptIn: 'ctpOptIn',
} as const;
